import React from "react";

const LAST_UPDATED = "26 December 2025";

export default function Terms() {
    return (
        <main className="min-h-screen bg-pink-50">
            <section className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-slate-900 mb-2">
                    Terms of Service
                </h1>
                <p className="text-sm text-slate-500 mb-8">
                    Last updated: {LAST_UPDATED}
                </p>

                <div className="space-y-6 text-slate-800 leading-relaxed">
                    <p>
                        Welcome to UnicorNation (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;). By accessing or
                        using our website, you agree to these Terms of Service. If you do
                        not agree with any part of these terms, please stop using the site.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">1. What UnicorNation Does</h2>
                    <p>
                        UnicorNation is an event listing and information service. We help
                        users discover queer parties, events, and related activities.
                    </p>
                    <p>
                        We do <span className="font-semibold">not</span> host, organise,
                        operate, or manage the events shown on the website. All events are
                        organised by third parties.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">
                        2. No Guarantees or Liability
                    </h2>
                    <p>
                        We do our best to keep information on the site accurate and up to
                        date, but we cannot guarantee it.
                    </p>
                    <p>
                        We are not responsible for, and will not be liable for, any loss,
                        damage, injury, or inconvenience resulting from:
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Changes to event details, pricing, or availability</li>
                        <li>Event delays, cancellations, or modifications</li>
                        <li>Decisions made based on information on this website</li>
                        <li>Issues arising from tickets, refunds, or payments</li>
                        <li>Any content, products, or services provided by third parties</li>
                    </ul>
                    <p>
                        You attend events and use external services at your own risk. Please
                        exercise your own judgment and take care of yourself and others.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">
                        3. External Merch and Affiliate Links
                    </h2>
                    <p>
                        Our site may include links to external merchandise stores and other
                        commercial offerings. Some of these links may be paid placements or
                        affiliate links.
                    </p>
                    <p>
                        We do not process payments, manage orders, or handle refunds for
                        external products or services. All transactions occur between you
                        and the external merchant or provider.
                    </p>
                    <p>
                        We are not responsible for product quality, delivery, suitability,
                        or any issues arising from your use of third-party websites.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">4. Email Subscriptions</h2>
                    <p>
                        If you subscribe to newsletters or event reminders, you consent to
                        receive those communications from us.
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>You can unsubscribe at any time using the link in our emails.</li>
                        <li>
                            We may use third-party tools or providers to deliver our email
                            communications.
                        </li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6">5. Intellectual Property</h2>
                    <p>
                        Unless otherwise stated, all content on UnicorNation, including
                        branding, logos, text, and design elements, is owned by us or used
                        with permission.
                    </p>
                    <p>
                        You may not copy, reproduce, distribute, or create derivative works
                        from our content without our prior written consent, except where
                        permitted by law.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">6. Acceptable Use</h2>
                    <p>You agree not to:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Interfere with or disrupt the operation of the website</li>
                        <li>
                            Attempt unauthorised access to our systems or the systems of
                            others
                        </li>
                        <li>Scrape or harvest data from the site for commercial use</li>
                        <li>
                            Use the site in any way that is unlawful, harmful, or abusive
                        </li>
                    </ul>

                    <h2 className="text-xl font-semibold mt-6">7. Changes to These Terms</h2>
                    <p>
                        We may update these Terms of Service from time to time. The updated
                        version will be posted on this page with a revised &quot;Last
                        updated&quot; date.
                    </p>
                    <p>
                        Your continued use of the site after any changes means you accept
                        the updated Terms.
                    </p>

                    <h2 className="text-xl font-semibold mt-6">8. Contact</h2>
                    <p>
                        If you have questions about these Terms, please contact us at:
                    </p>
                    <p className="font-medium">
                        contact@unicornation.com.au
                    </p>
                </div>
            </section>
        </main>
    );
}
